<template>
  <div>
    <div class="cont">
      <!-- Circular progress bar with dynamic color and value -->
      <v-progress-circular
        :rotate="135"
        :size="100"
        :width="9"
        :color="color"
        id="gauge"
        :value="scaledValue"
      >
        <!-- Rotating needle icon within the circular progress -->
        <v-icon
          id="needle"
          size="80"
          :style="'transform: rotate(' + gaugeDeg + 'deg);'"
          :color="color"
        >
          mdi-arrow-bottom-left
        </v-icon>

        <!-- Labels for different weather conditions -->
        <div class="stormylabel">Stormy</div>
        <div class="rainlabel">Rain</div>
        <div class="changelabel">Change</div>
        <div class="fairlabel">Fair</div>
        <div class="drylabel">Dry</div>
      </v-progress-circular>
    </div>
    <!-- Display the pressure value with the same color -->
    <b :style="{ color: color }">{{ percentage.val.toFixed(0) }} mbar</b>
  </div>
</template>

<script>
export default {
  props: {
    percentage: {
      type: Object,
      default() {
        return { scaled: 30, val: 1000 };
      },
    },
    color: {
      type: String,
      default: "primary", // Color for the needle and text
    },
  },
  computed: {
    // Scale the value to fit between 0 and 100 for the progress bar and needle
    scaledValue() {
      return ((this.percentage.val - 950) / (1050 - 950)) * 100; // Normalize between 0 to 100
    },
    gaugeDeg() {
      return (this.scaledValue / 100) * 270; // Rotate between 0° and 270° (Stormy to Dry)
    },
  },
};
</script>

<style scoped>
.cont {
  position: relative;
}

#needle {
  position: absolute;
  z-index: 1;
  top: 10px;
  left: 10px;
}

.changelabel {
  transform: rotate(0deg);
  position: absolute;
  top: -24px;
}

.stormylabel {
  transform: rotate(-115deg);
  position: absolute;
  left: -30px;
  top: 60px;
}

.rainlabel {
  transform: rotate(-54deg);
  position: absolute;
  left: -14px;
  top: 0px;
}

.fairlabel {
  transform: rotate(54deg);
  position: absolute;
  left: 85px;
  top: 0px;
}

.drylabel {
  transform: rotate(115deg);
  position: absolute;
  left: 98px;
  top: 60px;
}
</style>
